export const interviewScreenInstructions = [
	'1. You have joined via desktop/laptop and not with your phone',
	'2. You have a stable internet connection',
	'3. Your surroundings are well-lit and quiet',
];
